export const routes = [
  {
    path: '/cidade/:id/evento',
    component: () => import(/* webpackChunkName: "city" */ './components/List'),
    name: 'city.event',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/evento-em-lote',
    component: () => import(/* webpackChunkName: "city" */ './components/CalendarInBatch'),
    name: 'city.event.in.batch',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/encontros',
    component: () => import(/* webpackChunkName: "calendar" */ './components/ListMeetings'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/rotas',
    component: () => import(/* webpackChunkName: "calendar" */ './components/ConsultantRoute'),
    meta: {
      requiresAuth: true
    }
  }
]
